import React from 'react';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import FeatureTogglz from '@bibliocommons/feature-togglz';
import { TOGGLZ_FEATURES } from '@bibliocommons/constants-feature-togglz';

import { AggregateRatingContainer } from 'app/components/shared/AggregateRating';
import { UserRatingDropdownContainer } from 'app/components/shared/UserRatingDropdown';
import { BibJacketContainer } from 'app/components/bibs/shared/BibJacket';
import BibTitle from 'app/components/bibs/shared/BibTitle';
import BibSubTitle from 'app/components/bibs/shared/BibSubTitle';
import BibAuthors from 'app/components/bibs/shared/BibAuthors';
import EditionAndLanguageContainer from 'app/components/bibs/shared/EditionAndLanguage';
import BibExcerptContainer from 'app/components/bibs/BibPage/Transact/BibExcerpt/BibExcerptContainer';
import ConnectedLibraryPanelContainer from 'app/components/bibs/shared/ConnectedLibraryPanel/ConnectedLibraryPanelContainer';
import TransactPanelContainer from './TransactPanel/TransactPanelContainer';
import FormatChooserContainer from './FormatChooser/FormatChooserContainer';
import BibDescription from './BibDescription';
import HeaderBar from './HeaderBar';

import './Transact.scss';

export class Transact extends React.PureComponent {
  render() {
    const { catalogBib } = this.props;
    const metadataId = catalogBib.get('metadataId');

    return (
      <section className="cp-bib-transact container">
        <FeatureTogglz>
          {features => (features.get(TOGGLZ_FEATURES.NERF_BIB_PAGE_DEVELOPMENT) ? <HeaderBar /> : null)}
        </FeatureTogglz>
        <div className="row">
          <div className="col-md-2 col-lg-3">
            <BibJacketContainer />
            <div className="cp-bib-excerpt-desktop">
              <BibExcerptContainer />
            </div>
          </div>
          <div className="col-md-5 col-lg-5 col-xl-6 main-info">
            <BibTitle catalogBib={catalogBib} />
            <BibSubTitle catalogBib={catalogBib} />
            <BibAuthors catalogBib={catalogBib} />
            <EditionAndLanguageContainer />
            <div className="rating-info">
              <AggregateRatingContainer metadataId={metadataId} />
              <UserRatingDropdownContainer metadataId={metadataId} />
            </div>
            <FormatChooserContainer />
            <BibDescription catalogBib={catalogBib} />
            <div className="cp-bib-excerpt-mobile">
              <BibExcerptContainer />
            </div>
          </div>
          <div className="col-md-5 col-lg-4 col-xl-3 transact-panel">
            <TransactPanelContainer />
            <ConnectedLibraryPanelContainer />
          </div>
        </div>
      </section>
    );
  }
}

Transact.propTypes = {
  catalogBib: catalogBibShape.isRequired
};

export default Transact;
